import axios from 'axios';
import { SITE_URL } from "./_globals";
import { setUserStatus } from "../store/globals/actions";


// Проверить пользователя
export const getCashier = () => (dispatch) => {
    return postRequest('get-cashier', { }, true);
};


// Получить транзакции
export const getBills = (cashier_id, limit, offset) => (dispatch) => {
    const successFunc = (result) => {
        if (result.data.result === 'success') {
            return result.data.result.data;
        } else {
            return [];
        }
    };

    const failFunc = (result) => {
        return [];
    };

    return postRequest('get-transactions', { cashier_id, limit, offset }, true, successFunc, failFunc);
};


// Получить деньги
export const getMoneyTransaction = (qr, cashier_id, sum) => (dispatch) => {
    return postRequest('get-money-transaction', { qr, cashier_id, sum }, true);
};


// Вернуть деньги
export const backMoneyTransaction = (transaction_id, refund_sum) => (dispatch) => {
    return postRequest('back-money-transaction', { transaction_id, refund_sum }, true);
};

// Вернуть деньги
export const getTodaySum = (cashier_id) => {
    return postRequest('get-today-sum', { cashier_id }, true);
};


// Шаблон запроса
export const postRequest = (url, postData, needCheck = false, onSuccessCustom = undefined, onFailCustom = undefined, beforeStartCustom = undefined) => {
    const beforeStart = () => {
        if (beforeStartCustom !== undefined) beforeStartCustom();
    };
    const onSuccess = (result) => {
        if (onSuccessCustom !== undefined) onSuccessCustom(result);
        else return result.data;
    };
    const onFail = (error) => {
        if (onFailCustom !== undefined) onFailCustom(error);
        else return error;
    };

    beforeStart();

    let preparedPostData = new FormData();
    if (Object.keys(postData).length > 0) {
        Object.keys(postData).map((key) => {
            preparedPostData.append(key, postData[key]);
        });
    }

    if (needCheck) {
        let localUrl = (localStorage.getItem('url') !== undefined) ? localStorage.getItem('url') : 0;
        let vkId = (localStorage.getItem('vk_id') !== undefined) ? localStorage.getItem('vk_id') : 0;
        preparedPostData.append('url', localUrl);
        preparedPostData.append('vk_id', vkId);
    }

    const header = { ContentType: 'application/x-www-form-urlencoded' };

    return axios.post(SITE_URL + '/' + url + '/', preparedPostData, header)
        .then((data) => { onSuccess(data); return { result: 'success', data }})
        .catch((error) => { onFail(error); return { result: 'fail', error }})
};


// WEBPACK FOOTER //
// ./src/js/services/db.js